import { useNavigate } from "react-router-dom";
import { useRenterDashboardContext } from "../renter-dashboard/useRenterDashboardContext";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";


export function ButtonManageSubscription() {
  const navigate = useNavigate();
  const { renter } = useRenterDashboardContext();

  const handleClick = () => {
    if (renter?._id) {
      navigate(`/clientes/${renter._id}/assinaturas`);
    }
  };
  return (
    <ButtonWithLoader
      onClick={handleClick}
      disabled={!renter?._id}
    >
      Assinaturas
    </ButtonWithLoader>
  );
}

export default ButtonManageSubscription;